import { render, staticRenderFns } from "./tab-normal-pick.vue?vue&type=template&id=64974edc&scoped=true&"
import script from "./tab-normal-pick.vue?vue&type=script&lang=js&"
export * from "./tab-normal-pick.vue?vue&type=script&lang=js&"
import style0 from "./tab-normal-pick.vue?vue&type=style&index=0&id=64974edc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64974edc",
  null
  
)

export default component.exports